/** DataBest — Voice quick-report API. */
import api from "@/lib/axios";

export const voiceApi = {
    report: (individual_id, transcript) =>
        api
            .post(
                "/voice/report",
                { individual_id, transcript },
                { timeout: 90000 },
            )
            .then((r) => r.data),
    undo: (payload) =>
        api.post("/voice/report/undo", payload, { timeout: 30000 }).then((r) => r.data),
};
